import { PapiroConsole } from "src/utils/papiroConsole"

export function addCurrent(faq) {
    return {
        type: 'ADD_CURRENT',
        faq,
    }
}